import { render } from "./Company.vue?vue&type=template&id=ac7f205e&scoped=true&ts=true"
import script from "./Company.vue?vue&type=script&lang=ts"
export * from "./Company.vue?vue&type=script&lang=ts"

import "./Company.vue?vue&type=style&index=0&id=ac7f205e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7f205e"]])

export default __exports__